function makeXhr(method, url, data, track) { // for making requests
    var xhttp = new XMLHttpRequest();
    xhttp.open(method, url, true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.onload = function() {
      var status = xhttp.status;
      var response = xhttp.response;
      track( status, response)
    };
    xhttp.send(data ? JSON.stringify(data) : null);
}